import React from "react";

/**
 * "Convertir en action" — team-task side. Shared by NoteNotificationDropdown
 * and MyNotificationsView.
 *
 * Lazy-loaded: TaskCreationModal is a ~3200-line wizard living in the
 * lazy-routed Sectors chunk; a static import from the header bell would drag
 * it into the main bundle.
 */
export const LazyTaskCreationModal = React.lazy(() =>
  import("../Views/SectorsManagement/components/TaskCreationModal")
);

/**
 * Prefill props for TaskCreationModal from a `noteNotifications` document.
 * @param {Object} notif
 * @param {Function} t - i18next translate function
 * @returns {{initialTitle: string, initialDescription: string, sectorId: string|null}}
 */
export function buildTaskPrefillFromNotification(notif, t) {
  const author = notif.noteAuthorName || t("myNotifications.unknownAuthor");
  const content = (notif.noteContent || "").trim();
  const parts = [content];
  if (notif.actionUrl) parts.push(notif.actionUrl);

  return {
    initialTitle: t("activities.fromNote.defaultTitle", { author }),
    initialDescription: parts.filter(Boolean).join("\n\n"),
    sectorId: notif.sectorId || null,
  };
}

export default buildTaskPrefillFromNotification;
